import React from 'react';
import { PARTNER_COLORS } from '../constants';

export const PartnerCtaBand = ({ title, buttonLabel = 'Kontakta oss', mailto }) => (
  <section className="py-16 md:py-20">
    <div
      className="container-main max-w-3xl mx-auto text-center rounded-3xl px-8 py-14 md:py-16 shadow-sm border border-[#E5E7EB]"
      style={{ backgroundColor: PARTNER_COLORS.navy }}
    >
      <h2 className="text-2xl md:text-3xl font-black text-white mb-6">{title}</h2>
      <a
        href={mailto}
        className="inline-flex items-center justify-center rounded-full px-10 py-4 text-base font-bold text-white transition-all hover:shadow-lg hover:-translate-y-0.5"
        style={{ backgroundColor: PARTNER_COLORS.accent }}
      >
        {buttonLabel}
      </a>
      <p className="mt-4 text-sm text-white/60">
        {(mailto || '').replace(/^mailto:/, '').split('?')[0]}
      </p>
    </div>
  </section>
);
